/*
    Client Ddasboard

    This will be dashboard page for clients.  

    Clients can select a job and run and see the different components associated with it

    Components:
        -site map (no pig)
        -site map (live pig)
        -Live Track (non editing)
        -POI Inputs
        -notification settings

*/
import Select from 'react-select';
import { Button } from '../components/ui/buttons/Button';
import useJobOptions from '../hooks/useJobOptions';

/**
 * 
 * @returns {JSX.Element}
 * 
 * @todo Check if this page is still used
 * 
 * @category Pages
 */
export const ClientDashboard = () => {
    const { jobNameOptions } = useJobOptions(); 

    return (
        // PAGE WRAPPER
        <div className="flex flex-wrap justify-center items-start gap-4 p-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-4xl">
                {/* CONTROL WRAPPER */}
                <div className="flex flex-col border border-blue-900 p-4">
                    {/* SELECT JOB & RUN */}
                    <div className='pb-5 w-full'>
                        <label htmlFor='job-select'>Select a Job</label>
                        <Select 
                            name='job-select'
                            classNamePrefix="react-select"
                            options={jobNameOptions}
                        />
                    </div>
                    <div className='w-full'>
                        <label htmlFor='run-select'>Select a Run</label>
                        <Select 
                            name='run-select'
                            classNamePrefix="react-select"
                        />
                    </div>
                </div>

                {/* COMPONENT WRAPPER */}
                <div className="flex flex-col border border-red-900 p-4">
                    {/* SELECT COMPONENT */}
                    <div className='flex flex-col gap-2 w-full'>
                        <Button>Site Map</Button>
                        <Button>Live Track</Button>
                        <Button>Site Map W/ Pig</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
